// extracted by mini-css-extract-plugin
export default {"EnemiesView":"EnemiesView_EnemiesView__2jO81"};